var Dropdown;
(function (Dropdown) {
    myonce('dropdown', () => {
        const dropdown = document.querySelectorAll('.dropdown-container');
        if (dropdown.length) {
            dropdown.forEach((element) => {
                let button = element.querySelector('.dropdown-btn');
                let containerOptions = element.querySelector('.dropdown-options');
                button.addEventListener('click', () => {
                    containerOptions.classList.toggle('hide');
                    button.classList.toggle('rotate');
                });
                window.addEventListener('click', (event) => {
                    if (!button.contains(event.target)) {
                        containerOptions.classList.add('hide');
                        button.classList.remove('rotate');
                    }
                });
                const options = document.querySelectorAll('.option');
                options.forEach((option) => {
                    option.addEventListener('click', function () {
                        if (!this.classList.contains('selected')) {
                            this.parentNode
                                .querySelector('.option.selected')
                                .classList.remove('selected');
                            this.classList.add('selected');
                            this.closest('.dropdown-container').querySelector('.option-selected').textContent = this.textContent;
                        }
                    });
                });
            });
        }
    });
})(Dropdown || (Dropdown = {}));
